var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leading-snug",class:[
    `flex gap-3 rounded justify-between items-start overflow-hidden p-3 inline-dialog__${_vm.type}`,
    { 'items-center': _vm.alignCenter },
  ]},[_c('BubbleIcon',{attrs:{"background-class":_vm.iconBgColour,"icon":_vm.mainIcon,"foreground-class":"white"}}),_c('div',{staticClass:"grow all:flex gap-1",class:{
      'flex-col items-start': _vm.linkPosition === _vm.PositionEnum.Bottom,
      'flex-col-reverse items-start': _vm.linkPosition === _vm.PositionEnum.Top,
      'items-center justify-between': [
        _vm.PositionEnum.Right,
        _vm.PositionEnum.Left,
      ].includes(_vm.linkPosition),
      'flex-row-reverse': _vm.linkPosition === _vm.PositionEnum.Left,
    }},[_c('div',{staticClass:"all:flex flex-col gap-1"},[(_vm.header)?_c('div',{staticClass:"header w-full"},[_c('h4',[_c('strong',[_vm._v(_vm._s(_vm.header))])])]):_vm._e(),(_vm.$slots.message || _vm.message)?_c('p',{staticClass:"all:flex h-full items-center mb-0"},[(_vm.$slots.message)?[_vm._t("message")]:[_vm._v(" "+_vm._s(_vm.message)+" ")]],2):_vm._e()]),_vm._t("link")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }